import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUIIconsModule } from '../icons/core-ui-icons.module';
import { CoreUIFlashToastComponent } from './flash-toast.component';

@NgModule({
  declarations: [
    CoreUIFlashToastComponent,
  ],
  imports: [
    CommonModule,
    CoreUIIconsModule,
  ],
  exports: [
    CoreUIFlashToastComponent,
  ],
})
export class CoreUIFlashToastModule {}
